import React from 'react';

import { Redirect } from 'react-router-dom'

import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose';
import { logout } from '../../store/actions/login';

/*
 This is a workaround for handling when the session has times out.
 We should do this from loading/index.js
 */
const Logout =()=>{
    return (<Redirect to="/" />);
};

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => {
            dispatch(logout())
        }
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.logout();
    }
};

export default compose(
    connect(null, mapDispatchToProps),
    lifecycle(lifecycleValue),
)(Logout);



// WEBPACK FOOTER //
// ./src/components/logout/Logout.js